import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ConfigForm } from './config-form';
import { AutoCompleteField } from './fields';
import { isNotNullOrUndefinedOrEmpty } from "../helpers";

@Component({
    selector: 'ui-form',
    templateUrl: './form.component.html',
    styleUrls: ['./form.component.scss'],
    standalone: false
})
export class FormComponent<T> implements OnInit {

    @Input() public config!: ConfigForm;
    @Input() public btnText: string = '';
    @Input() public disableBtn: boolean = true;
    @Input() public disabled: boolean = false;
    @Input() public entity!: T;
    @Input() public showBtn = true;

    @Output() submitEmitter = new EventEmitter<any>();

    @Input() formGroup: UntypedFormGroup = new UntypedFormGroup({});
    @Output() formGroupChanged = new EventEmitter<UntypedFormGroup>();

    constructor(private formBuilder: UntypedFormBuilder, private changeDetection: ChangeDetectorRef) { }

    ngOnInit(): void {
        const group: { [p: string]: any } = {};

        this.config.fields.forEach((field) => {
            if (field.type === 'Autocomplete') {
                group[field.property] = this.trataAutoComplete(field as AutoCompleteField);
            } else {
                group[field.property] = this.trataPadrao(field.validations, field.value);
            }
        });
        this.formGroup = this.formBuilder.group(group, { updateOn: 'change' });
        this.formGroupChanged.emit(this.formGroup);
        if (this.entity) {
            this.formGroup.patchValue(this.entity);
        }

        if (this.disabled) {
            this.formGroup.disable();
        }
    }

    submitForm() {
        if (!this.disableBtn || (this.formGroup.valid && !this.formGroup.disabled && (this.formGroup.touched || this.formGroup.dirty))) {
            this.submitEmitter.emit(this.formGroup);
        }
    }

    private trataAutoComplete(field: AutoCompleteField) {
        const value: any = {};

        let entityValue = 'id';
        let entityText = 'nome';

        if (isNotNullOrUndefinedOrEmpty(field.entityValue)) {
            entityValue = field.entityValue;
        }

        if (isNotNullOrUndefinedOrEmpty(field.entityText)) {
            entityText = field.entityText;
        }

        const entityProperty = this.entity?.[field.property];

        value[entityValue] = new UntypedFormControl(
            entityProperty?.[entityValue] ?? null,
            {
                validators: field.validations,
                updateOn: 'change'
            }
        );

        value[entityText] = new UntypedFormControl(
            entityProperty?.[entityText] ?? null,
            {
                validators: field.validations,
                updateOn: 'change'
            }
        );

        value[field.property] = new UntypedFormControl(
            entityProperty ?? null,
            {
                validators: field.validations,
                updateOn: 'change'
            }
        );

        return new UntypedFormGroup(value, { updateOn: 'change' });
    }

    private trataPadrao(validations: any, value: any) {
        const val = value ? value(this.entity) : null;
        return new UntypedFormControl(val, {
            validators: validations,
            updateOn: 'change'
        });
    }
    
    processarEsconder(esconder: boolean | ((value: T) => boolean)): boolean {
        let retornoEsconder = esconder instanceof Function ? esconder(this.entity) : esconder;
        return retornoEsconder;
    }
}
